<div *ngIf="showBeneficiary && params?.payment=='form'" class="beneficiary-details d-sm-none">
  <div *ngIf="vars.selectedKCart && isMobile" class="back-action" (click)="back()"><em class="material-icons">arrow_back_ios</em> Back</div>
  <div class="flex-div align-items-center">
    <ng-template [ngTemplateOutlet]="profilePic"></ng-template>
    <div class="details">
      <span>Contribute to:</span>
      <div class="bene-name">{{fundraiser?.beneficiaryname?.info_1}}</div>
      <span class="heading">{{'Stories.donations.beneficiary' | translatePipe | async}}<i class="material-icons check-circle">check_circle</i></span>
    </div>
    <div class="ketto-assured-logo">
      <app-ketto-assured *ngIf="type==='v1'"></app-ketto-assured>
      <app-ketto-assured-v2 *ngIf="type==='v2'"></app-ketto-assured-v2>
    </div>
  </div>
</div>
<header *ngIf="!vars.selectedKCart || !isMobile || (vars.selectedKCart && params?.payment!=='form' && isMobile)" [ngClass]="{'white-header': (params?.payment=='options' || vars?.fundraiser?.is_multi_patient_campaign) && isMobile}">
  <div *ngIf="(params?.payment==='options' || !util.isApp()) && !vars.selected_insurance && (!isStandAlone || params?.payment==='options') && !vars.isOrderLoading" class="action-icons">
    <button type="button" (click)="back()" mat-icon-button>
      <mat-icon>chevron_left</mat-icon>
      <!-- <span class="back-txt">{{'Stories.donations.back' | translatePipe | async}}</span> -->
    </button>
  </div>
  <div *ngIf="!(params?.payment==='form' && isMobile) && !vars.selected_insurance && (!vars.selectedKCart || params?.payment!=='form')" class="title">{{getTitle(params.payment, params?.op || params?.method)}}</div>
  <div *ngIf="vars.selected_insurance && !vars.couponDetails?.discount_amount" class="title partner">Total amount ₹{{vars.selected_insurance.plan_amount}}</div>
  <div *ngIf="vars.selected_insurance && vars.couponDetails?.discount_amount" class="title partner">Total amount ₹{{vars.couponDetails?.payable_amount}} <span class="before-discount">₹{{vars.selected_insurance.plan_amount}}</span></div>
  <div *ngIf="params?.type!=='lead' && params.payment!=='options' && !vars.selectedKCart" class='you-are-donating'>
    <div class="title" *ngIf="isMobile">{{'Stories.donations.donatingIn' | translatePipe | async}}</div>
    <div class="currency-dropdown">
      <app-currency-dropdown *ngIf="supportedCurrencies" [currencies]="supportedCurrencies"
                              [selectedCurrency]="currency" (userSelectionCurrency)="setCurrency($event)">
      </app-currency-dropdown>
    </div>
  </div>
</header>

<div *ngIf="vars.selectedKCart && isMobile && params.payment!=='options'" class="extra-product-details">
  <app-component-loader [load]="true" selector="app-extra-product-details" />
</div>

<div *ngIf="vars?.fundraiser?.is_multi_patient_campaign && isMobile && vars?.pageName === 'stories' && params?.payment!=='options'" class="multi-patient-dropdown">
  <app-component-loader [load]="true" selector="app-multi-patient-dropdown" />
</div>

<ng-template #profilePic>
  <div *ngIf="fundraiser?.media_beneficiary" class="profile-img">
    <img loading="lazy" alt="donor_img" [attr.data-src]="fundraiser?.media_beneficiary?.cdn_path" [alt]="'Profile Pic - '+vars?.beneficiary?.full_name" />
  </div>
  <i *ngIf="!fundraiser?.media_beneficiary" class="icon-user1"></i>
</ng-template>
